import { PageHeader, message, Popconfirm, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { TableItem, ButtonItem, SegmentedItem} from '../../../Components/Items'
import { connect } from "react-redux";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";


class Impuestos extends Component {
  state = {
    todasImpuesto: [],
    loading: false,
    valor: 1
  }
  componentDidMount() {
    this.consultarImpuestos(this.state.valor);
  }

  consultarImpuestos(valor) {
    this.setState({loading: true})
    axios
    .post(
      "impuestos/selectTodosImpuestos",
      { empresaId: this.props.empresaId, valor: valor, },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.status === 404) {
        this.setState({ todasImpuesto: [] });
      } else {
        this.setState({
          todasImpuesto: res.data.map(value => {
            return {...value, accion: { _id: value._id, estado: value.estado }}
          }),
        });
      }
    });
  }
  agregarImpuesto(){
    this.props.history.push('/panel/agregarImpuesto')
  }
  editarImpuesto(id){
    this.props.history.push('/panel/editarImpuesto', {id})
  }
  deshabilitarImpuesto(value) {
    axios
      .post(
        "impuestos/deshabilitarImpuesto",
        { impuestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Impuesto deshabilitado");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.consultarImpuestos(this.state.valor);
      });
  }
  habilitarImpuesto(value) {
    axios
      .post(
        "impuestos/habilitarImpuesto",
        { impuestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Impuesto habilitado");
        } else {
          message.error("Sucedio un error y no se pudo habilitar");
        }
        this.consultarImpuestos(this.state.valor);
      });
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value) => {
          let buttons = [];

          const puedeEditar = this.props.permisoEditarImpuesto;
          buttons.push(
            <Tooltip key="editar" title={puedeEditar ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => puedeEditar && this.editarImpuesto(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeDeshabilitarHabilitar = this.props.permisoDeshabilitarImpuesto;
          if (value.estado === 1) {
            buttons.push(
              <Popconfirm
                key="deshabilitar"
                title="Seguro que quieres deshabilitar este impuesto"
                onConfirm={() => this.deshabilitarImpuesto(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!puedeDeshabilitarHabilitar}
              >
                <Tooltip title={puedeDeshabilitarHabilitar ? "Deshabilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key="habilitar"
                title="Seguro que quieres habilitar este impuesto"
                onConfirm={() => this.habilitarImpuesto(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!puedeDeshabilitarHabilitar}
              >
                <Tooltip title={puedeDeshabilitarHabilitar ? "Habilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Impuestos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
            {window.innerWidth > 1000 &&
            <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarImpuestos(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
          }
            {this.props.permisoAgregarImpuesto &&
            <ButtonItem
              type="primary"
              key="agregarImpuesto"
              olivo
              onClick={this.agregarImpuesto.bind(this)}
               className="botonAgregar"
            >
              Agregar Impuesto
            </ButtonItem>}
          </>
        }
        />
        <TableItem 
          loading={this.state.loading} 
          size='small' 
          dataSource={this.state.todasImpuesto} 
          columns={columns} 
          onRow={(record) => ({
            onDoubleClick: () => this.editarImpuesto(record._id),
          })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarImpuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cde17f30e81b54183cfa6")?.activado,
    permisoEditarImpuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cde45f30e81b54183cfa7")?.activado,
    permisoDeshabilitarImpuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce810f30e81b54183cfb8")?.activado,
  };
};

export default connect(mapStateToProps)(Impuestos);